<div style="display: flex">
    <p-dialog header="Confirmation" [visible]="showElementSelectAllConfirmation" [maximizable]="false">
        <p>{{this.selectNotificationText}}</p>
        <ng-template #footer>
            <button pButton pRipple severity="secondary" label="Yes" (click)="assignAllElements()"></button>
            <button pButton pRipple severity="secondary" label="No" (click)="showElementSelectAllConfirmation = false"></button>
        </ng-template>
    </p-dialog>
</div>
<div style="display: flex">
    <p-dialog header="Confirmation" [visible]="showMemberSelectAllConfirmation" [maximizable]="false">
        <p>{{this.selectNotificationText}}</p>
        <ng-template #footer>
            <button pButton pRipple severity="secondary" label="Yes" (click)="assignAllMembers()"></button>
            <button pButton pRipple severity="secondary" label="No" (click)="showMemberSelectAllConfirmation = false"></button>
        </ng-template>
    </p-dialog>
</div>
<div style="display: flex">
    <p-dialog header="Confirmation" [(visible)]="deleteVisible" [maximizable]="false">
        <p>
            Are you sure you want to delete the selected group?
        </p>
        <ng-template #footer>
            <button pButton pRipple text severity="primary" #cancel label="Cancel" (click)="this.deleteVisible = false;"></button>
            <button pButton pRipple text severity="danger" (click)="deleteGroupClicked()" label="Delete"></button>
        </ng-template>
    </p-dialog>
</div>

<div hidden>
    <div>
        <mat-checkbox id="membersCbxColumnHeader" #membersCbxColumnHeader
            [(ngModel)]="membersSelectedRowsCheckbox.checked"
            [(indeterminate)]="membersSelectedRowsCheckbox.indeterminate" style="border-color: blue"></mat-checkbox>
    </div>
</div>
<div hidden>
    <div>
        <mat-checkbox id="elementsCbxColumnHeader" #elementsCbxColumnHeader
            [(ngModel)]="elementsSelectedRowsCheckbox.checked"
            [(indeterminate)]="elementsSelectedRowsCheckbox.indeterminate" [disabled]="this.elementsCheckboxFlag">
        </mat-checkbox>
    </div>
</div>

<div hidden>
    <p-checkbox id="superuserCbx" #superuserCbx [(ngModel)]="superUserCbx.checked"
        [disabled]="this.superuserCbxFlag"></p-checkbox>
</div>

<div hidden>
    <div>
        <button id="assignButton" #assignButton mat-button color="primary">
            Direct Reports
        </button>
    </div>
</div>

<div hidden>
    <ng-template #loading>
        <div>Loading...<i class="fa fa-spinner fa-spin"></i></div>
    </ng-template>
</div>

<div id="divElementColumnHeader">
    <ng-template #header>
        <div class="tabulator-col-title">{{ elementColumnHeader }}</div>
        <div class="tabulator-arrow"></div>
    </ng-template>
</div>

<div id="divMemberColumnHeader">
    <ng-template #header>
        <div class="tabulator-col-title">{{ elementColumnHeader }}</div>
        <div class="tabulator-arrow"></div>
    </ng-template>
</div>

<div style="display: flex">
    <p-dialog header="Warning for attempted change" [(visible)]="showAssignAdminPopup" [maximizable]="false">
        <h4>
            This administrator cannot be removed because at least one administrator must remain assigned at all times. 
            Please assign another administrator before removing this user.
        </h4>
        <ng-template #footer>
            <button type="button" pButton text severity="success" (click)="assignAdminWarningAccepted()" label="OK"></button>
        </ng-template>
    </p-dialog>
    <p-dialog header="Administrator limit reached" [(visible)]="showAdminCountExceededPopup" [maximizable]="false">
        <h4>
            {{ adminCountExceededMessage }}
        </h4>
        <ng-template #footer>
            <button type="button" pButton text severity="success" (click)="adminCountExceededWarningAccepted()" label="OK"></button>
            <button type="button" pButton text severity="primary" (click)="navigateToEfaactStore()" label="Manage Administrators"></button>
        </ng-template>
    </p-dialog>
</div>

<div style="display: flex;">
    <p-dialog header="Are you sure?" [(visible)]="showAssignAreYouSure" [maximizable]="false" [closable]="false" style="max-width: 30em !important;">
        <h4>
            {{this.assignAreYouSureMsg}}
        </h4>
        <ng-template #footer>
            <button type="button" pButton text severity="success" (click)="assignGroupMember()" label="OK"></button>
            <button type="button" pButton text severity="danger" (click)="cancelAssignGroupMember()" label="Cancel"></button>
        </ng-template>
    </p-dialog>
</div>

<p-toolbar *ngIf="this.IsManageRoles == false" styleClass="mt-2 mb-1">
    <div>
        <span class="font-semibold text-base mb-1">Select to view group</span>
        <div class="flex mt-2">
            <form [formGroup]="filterFormGroup" #filterForm="ngForm" id="filterForm">
                <div class="flex items-center">
                    <div *ngIf="this.IsManageRoles == false">
                        <div *ngIf="groupTypes as items; else loading">
                            <p-floatlabel variant="on">
                                <p-select
                                    [showClear]="true"
                                    styleClass="w-14rem"
                                    inputId="gcddl"
                                    appendTo="body"
                                    [options]="items"
                                    formControlName="groupTypes"
                                    optionLabel="GroupType"
                                    dataKey="Categoryid">
                                </p-select>
                                <label for="gcddl">Group Category</label>
                            </p-floatlabel>
                        </div>
                    </div>

                    <div class="mx-3" *ngIf="groups as items; else loading">
                        <div *ngIf="this.IsManageRoles == false">
                            <p-floatlabel variant="on">
                                <p-select
                                    styleClass="w-12rem"
                                    [showClear]="true"
                                    inputId="gnddl"
                                    appendTo="body"
                                    [options]="items"
                                    formControlName="groups"
                                    optionLabel="GroupName"
                                    dataKey="GroupID">
                                </p-select>
                                <label for="gcddl">{{ this.dropdownPlaceholderText }}</label>
                            </p-floatlabel>
                        </div>
                    </div>

                    <div *ngIf="this.IsManageRoles == false">
                        <div *ngIf="groupElementTypes as items; else loading">
                            <p-floatlabel variant="on">
                                <p-select
                                    styleClass="w-12rem"
                                    [showClear]="true"
                                    inputId="gnddl"
                                    appendTo="body"
                                    [options]="items"
                                    formControlName="elementTypes"
                                    optionLabel="GroupElementType">
                                </p-select>
                                <label for="gcddl">Group Items</label>
                            </p-floatlabel>
                        </div>
                    </div>
                    <span *ngIf="showProcessToggle == true" style="margin: 0; padding: 0;" class="button-bar">
                            <div class="p-field-radiobutton" style="margin-bottom: .5em;">
                                <p-radioButton name="process" value="reportadmin" formControlName="reportadmin" inputId="reportadmin"></p-radioButton>
                                @if (this.caFilterFormGroup.controls['reportadmin'].value == 'reportadmin') {
                                    <strong>Assign report admins</strong>
                                }
                                @else {
                                    <label style="padding-top: .71em; margin-bottom: 0" for="reportadmin">Assign report admins</label>
                                }
                            </div>
                            <div class="p-field-radiobutton" style="margin-bottom: .5em;">
                                <p-radioButton name="process" value="processadmin" formControlName="processadmin" inputId="customadmin"></p-radioButton>
                                @if (this.caFilterFormGroup.controls['processadmin'].value == 'processadmin') {
                                    <strong>Assign custom process admins</strong>
                                }
                                @else {
                                    <label style="padding-top: .71em; margin-bottom: 0" for="customadmin">Assign custom process admins</label>
                                }
                            </div>

                    </span>
                </div>
            </form>

            @if (this.IsManageRoles == false) {
                <form [formGroup]="maintenanceFormGroup" #updateForm="ngForm" id="maintenance">
                    <div style="
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            flex-wrap: wrap;
                            justify-content: left;
                        ">
                        <div>
                            <button
                                pButton
                                pRipple
                                text
                                rounded
                                #deleteGroup
                                class="ml-3"
                                icon="pi pi-trash"
                                severity="danger"
                                pTooltip="Delete selected group."
                                (click)="showDelete()">
                            </button>
                        </div>
                        <div class="ml-6">
                            <button
                                pButton
                                pRipple
                                #addGroup
                                severity="primary"
                                label="Add Group"
                                (click)="addGroupClicked()">
                            </button>
                        </div>
                    </div>
                </form>
            }
        </div>
    </div>
</p-toolbar>

<p-panel styleClass="mt-2">
    <ng-template #header>
        @if(this.selectedGroup != null) {
            <div>
                <p-toolbar *ngIf="this.process.ProcessID == 141">
                    <div>
                        <span class="font-semibold text-base mb-1">Select to view group</span>
                        <form [formGroup]="caFilterFormGroup" #filterForm="ngForm" id="filterForm">
                            <div class="flex items-center">
                                <span *ngIf="showProcessToggle == true" style="margin: 0; padding: 0;" class="flex items-center gap-2">
                                        <div class="p-field-radiobutton" style="margin-bottom: .5em;">
                                            <p-radioButton name="process" value="reportadmin" formControlName="reportadmin" inputId="reportadmin"></p-radioButton>
                                            <label style="padding-top: .71em; margin-bottom: 0" for="reportadmin">Assign report admins</label>
                                        </div>
                                        <div class="p-field-radiobutton" style="margin-bottom: .5em;">
                                            <p-radioButton name="process" value="processadmin" formControlName="processadmin" inputId="customadmin"></p-radioButton>
                                            <label style="padding-top: .71em; margin-bottom: 0" for="customadmin">Assign custom process admins</label>
                                        </div>
                                </span>
                            </div>
                        </form>
                    </div>
                </p-toolbar>
                <div>
                    <span class="block text-900 pb-0 text-xl font-medium">{{this.selectedGroup.GroupName}}</span>
                </div>
            </div>
        }
        <!--@else {
            @if (this.groupHeaderInitialized) {
                <span class="block text-900 pb-0 text-xl font-medium">No group selected.</span>
            }
        }-->
    </ng-template>

    @if(this.selectedGroup != null) {
        <p class="text-600 mt-0 mb-0 pt-0">{{this.purpose}}</p>
    }
    @if (isAdministratorRolesPage && adminCount != null) {
        <div class="groups-unused-admin-slots-banner mt-2 mb-1">
            <div class="groups-admin-license-notice" role="status">
                <span class="groups-admin-license-notice__cta">Certified Advisors receive administrator-level access at no additional licensing cost and are excluded from the total licensed administrator count. 
                    They are not billed as additional administrator licenses and are excluded from the licensed administrator count.</span>
                <p class="groups-admin-license-notice__line">
                    <span class="font-medium text-900">Certified Advisors:</span>
                    {{ getAdvisorAdminCount() }}
                </p>
                <p class="groups-admin-license-notice__line">
                    <span class="font-medium text-900">Assigned Certified Advisors:</span>
                    {{ getAssignedAdvisorAdminCount() }}
                </p>
                <br/> 
                <p class="groups-admin-license-notice__line">
                    <span class="font-medium text-900">Licensed administrators:</span>
                    {{ adminCount }}
                </p>
                <p class="groups-admin-license-notice__line">
                    <span class="font-medium text-900">Assigned administrators:</span>
                    {{ getAssignedAdministratorCount() }}
                </p>
                               
                <div class="groups-admin-license-notice__actions">
                    <span class="groups-admin-license-notice__cta">To add/remove an administrator license, navigate to Manage Administrators:</span>
                    <button
                        pButton
                        pRipple
                        type="button"
                        severity="primary"
                        label="Manage Administrators"
                        (click)="navigateToEfaactStore()">
                    </button>
                </div>
            </div>
        </div>
    }

    <div class="grid mt-1 groups-panels">
        <div [ngClass]="{ 'col-12 xl:col-6': this.HasElements, 'col-12': !this.HasElements }">
            <p-panel>
                <ng-template #header>
                    <span class="font-semibold text-base">User(s)</span>
                </ng-template>
                <div class="flex justify-start flex-wrap">
                    @if (showBulkAssignButtons) {
                        <button pRipple pButton text severity="primary" (click)="assignAllMembersClicked()" label="Assign All"></button>
                        <button pRipple pButton text severity="primary" (click)="unassignAllMembersClicked()" label="Unassign All"></button>
                    }
                    <div class="flex items-center ml-2 mt-2 mr-2">
                        <p-checkbox inputId="label" id="showSelectedToggle" #showSelectedToggle
                            (onChange)="onToggleShowSelected($event)"
                            [(ngModel)]="this.showSelectedRowsOnly" [binary]="true">
                        </p-checkbox>
                        <label for="label" class="ml-2"> {{this.memSwitchDesc}} </label>
                    </div>
                    <!-- <p-floatlabel variant="on" class="justify-end">
                        <p-autocomplete appendTo="body" [(ngModel)]="filteredMember" [dropdown]="true" [suggestions]="groupMembers" (completeMethod)="search($event)" optionLabel="UserName" inputId="on_label" />
                        <label for="on_label">Filter users...</label>
                    </p-floatlabel> -->
                    <p-message *ngIf="showProcessToggle == true" severity="info" [text]="this.processToggleText"></p-message>
                    <!-- <div class="bar" [hidden]="!tabGroupMembers" id="divSelectAllMembers" style="display: none; clear: none;">
                        <p-message severity="warn" [text]="selectNotificationText" styleClass="mr-2"></p-message>
                        <button pButton style="margin-right: 0.25vw" severity="secondary"
                            label="Yes" #selectAllMembers></button>
                        <button pButton style="margin-right: 0.5vw" severity="secondary"
                            label="No" #dontSelectAllMembers></button>
                    </div> -->
                </div>
                <div class="groups-table-host">
                    <p-table
                        [value]="displayedGroupMembers"
                        dataKey="ListID"
                        [scrollable]="true"
                        scrollHeight="55vh"
                        scrollDirection="both"
                        [tableStyle]="{ 'min-width': '100%' }"
                        styleClass="p-datatable-sm groups-table">
                        <ng-template #header>
                            <tr>
                                <th class="assigned-cell" pTooltip="Assigned">Assigned</th>
                                <th class="status-cell groups-col-header-tight" pTooltip="Status"></th>
                                <th class="groups-col-name">
                                    User
                                    <p-columnFilter field="UserName" type="text" matchMode="contains" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" class="ml-auto">
                                        <ng-template #filter let-value let-filter="filterCallback">
                                            <input
                                                pInputText
                                                type="text"
                                                [ngModel]="value"
                                                (ngModelChange)="memberNameFilter = $event; filter($event)"
                                                placeholder="Filter users..." />
                                        </ng-template>
                                    </p-columnFilter>
                                </th>
                                <th *ngIf="isMemberColumnVisible('assign')" class="groups-col-action">Actions</th>
                                <th *ngIf="isMemberColumnVisible('alt')" class="groups-col-action">My Alternates</th>
                                <th *ngIf="isMemberColumnVisible('altFor')" class="groups-col-action">Alternate For</th>
                                <th *ngIf="isMemberColumnVisible('IsAltSupervisorOnly')" class="groups-col-check">Alternate Only</th>
                                <th *ngIf="isMemberColumnVisible('IsAltForAllSupervisors')" class="groups-col-check">Alt For All Supervisors</th>
                                <th *ngIf="isMemberColumnVisible('AllowSuperUser')" class="groups-col-check">Super User</th>
                                <th *ngIf="isMemberColumnVisible('IsAdvisorAdmin')" class="groups-col-check">Certified Advisor</th>
                                <th *ngIf="isMemberColumnVisible('Allowauths')" class="groups-col-check">Authorizations</th>
                            </tr>
                        </ng-template>
                        <ng-template #body let-member>
                            <tr>
                                <td class="assigned-cell">
                                    <div
                                        class="groups-member-assign-toggle"
                                        (click)="onMemberAssignedToggle(member, $event)">
                                        <p-checkbox
                                            [binary]="true"
                                            [ngModel]="member.selected"
                                            [readonly]="true">
                                        </p-checkbox>
                                    </div>
                                </td>
                                <td class="status-cell">
                                    <i
                                        *ngIf="member.Status"
                                        class="line-height-2 text-xl"
                                        [class]="getStatusIcon(member.Status.StatusCode).iconText"
                                        [title]="member.Status.Message">
                                    </i>
                                </td>
                                <td class="groups-col-name" [pTooltip]="member.UserName" tooltipPosition="top">{{ member.UserName }}</td>
                                <td *ngIf="isMemberColumnVisible('assign')" class="groups-col-action">
                                    <button
                                        *ngIf="member.selected && (member.GroupID === 12024 || member.GroupID === 12025 || member.GroupID === 12030)"
                                        pButton
                                        pRipple
                                        text
                                        size="small"
                                        (click)="onMemberActionClick(member)"
                                        [label]="member.GroupID === 12024 ? 'Direct Reports' : member.GroupID === 12025 ? 'Tasks' : 'Consultants'">
                                    </button>
                                </td>
                                <td *ngIf="isMemberColumnVisible('alt')" class="groups-col-action">
                                    <button
                                        *ngIf="member.selected && member.GroupID === 12024 && (member.IsAltSupervisorOnly === false || member.IsAltSupervisorOnly == null)"
                                        pButton
                                        pRipple
                                        text
                                        size="small"
                                        label="My Alternates"
                                        (click)="onMemberAltClick(member)">
                                    </button>
                                </td>
                                <td *ngIf="isMemberColumnVisible('altFor')" class="groups-col-action">
                                    <button
                                        *ngIf="member.selected && member.GroupID === 12024"
                                        pButton
                                        pRipple
                                        text
                                        size="small"
                                        label="Alternate For"
                                        (click)="onMemberAltForClick(member)">
                                    </button>
                                </td>
                                <td *ngIf="isMemberColumnVisible('IsAltSupervisorOnly')" class="groups-col-check">
                                    <div class="groups-cell-flex-center">
                                        <p-checkbox [binary]="true" [(ngModel)]="member.IsAltSupervisorOnly" [disabled]="true"></p-checkbox>
                                    </div>
                                </td>
                                <td *ngIf="isMemberColumnVisible('IsAltForAllSupervisors')" class="groups-col-check">
                                    <div class="groups-cell-flex-center">
                                        <p-checkbox
                                            [binary]="true"
                                            [(ngModel)]="member.IsAltForAllSupervisors"
                                            (onChange)="onToggleMemberPermission(member, 'IsAltForAllSupervisors', 'This will remove Alternate Supervisor access.')">
                                        </p-checkbox>
                                    </div>
                                </td>
                                <td *ngIf="isMemberColumnVisible('AllowSuperUser')" class="groups-col-check">
                                    <div class="groups-cell-flex-center">
                                        <p-checkbox
                                            [binary]="true"
                                            [(ngModel)]="member.AllowSuperUser"
                                            (onChange)="onToggleMemberPermission(member, 'AllowSuperUser', 'This will remove Super User permissions.')">
                                        </p-checkbox>
                                    </div>
                                </td>
                                <td *ngIf="isMemberColumnVisible('IsAdvisorAdmin')" class="groups-col-check">
                                    <div class="groups-cell-flex-center">
                                        <p-checkbox
                                            [binary]="true"
                                            [(ngModel)]="member.IsAdvisorAdmin"
                                            [disabled]="true">
                                        </p-checkbox>
                                    </div>
                                </td>
                                <td *ngIf="isMemberColumnVisible('Allowauths')" class="groups-col-check">
                                    <div class="groups-cell-flex-center">
                                        <p-checkbox
                                            [binary]="true"
                                            [(ngModel)]="member.Allowauths"
                                            (onChange)="onToggleMemberPermission(member, 'Allowauths', 'This will remove Access to Authorizations.')">
                                        </p-checkbox>
                                    </div>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
                <div class="page-overlay" #tabOverlay id="tabOverlay" tabindex="0" style="display: none"></div>
            </p-panel>
        </div>
        <div class="col-12 xl:col-6" *ngIf="this.HasElements">
                <p-panel>
                    <ng-template #header>
                        <span class="font-semibold text-base">{{ this.elementColumnHeader }}</span>
                    </ng-template>
                    <div class="flex justify-start flex-wrap">
                        @if (showBulkAssignButtons) {
                            <button pRipple pButton text severity="primary" (click)="assignAllElementsClicked()" label="Assign All"></button>
                            <button pRipple pButton text severity="primary" (click)="unassignAllElementsClicked()" label="Unassign All"></button>
                        }
                        <span class="ml-2 mt-2">
                            <div class="flex items-center">
                                <p-checkbox id="showSelectedEleToggle" #showSelectedEleToggle
                                    (onChange)="onToggleShowSelectedEle($event)"
                                    [(ngModel)]="this.showSelectedEleRowsOnly" [binary]="true">
                                </p-checkbox>
                                <label for="label" class="ml-2"> {{this.eleSwitchDesc}} </label>
                            </div>
                        </span>
                        <!-- <div class="bar" [hidden]="!tabElements" id="divSelectAllElements" style="display: none; clear: none;">
                            <p-message severity="warn" [text]="selectNotificationText" styleClass="mr-2"></p-message>
                            <button pButton style="margin-right: 0.25vw" severity="secondary"
                                label="Yes" #selectAllElements></button>
                            <button pButton style="margin-right: 0.5vw" severity="secondary"
                                label="No" #dontSelectAllElements></button>
                        </div> -->
                    </div>
                    <div class="groups-table-host">
                        <p-table
                            [value]="displayedGroupElements"
                            dataKey="GroupElementID"
                            [scrollable]="true"
                            scrollHeight="55vh"
                            scrollDirection="both"
                            [tableStyle]="{ 'min-width': '100%' }"
                            styleClass="p-datatable-sm groups-table">
                            <ng-template #header>
                                <tr>
                                    <th class="assigned-cell" pTooltip="Assigned">Assigned</th>
                                    <th class="groups-col-name">
                                        {{ this.elementColumnHeader }}
                                        <p-columnFilter field="ElementName" type="text" matchMode="contains" display="menu" [showMatchModes]="false" [showOperator]="false" [showAddButton]="false" class="ml-auto">
                                            <ng-template #filter let-value let-filter="filterCallback">
                                                <input
                                                    pInputText
                                                    type="text"
                                                    [ngModel]="value"
                                                    (ngModelChange)="elementNameFilter = $event; filter($event)"
                                                    placeholder="Filter items..." />
                                            </ng-template>
                                        </p-columnFilter>
                                    </th>
                                </tr>
                            </ng-template>
                            <ng-template #body let-element>
                                <tr>
                                    <td class="assigned-cell">
                                        <div>
                                            <p-checkbox
                                                [binary]="true"
                                                [(ngModel)]="element.selected"
                                                (onChange)="onElementAssignedChange(element)">
                                            </p-checkbox>
                                        </div>
                                    </td>
                                    <td class="groups-col-name">{{ element.ElementName }}</td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </div>
                    <div class="page-overlay" #tabOverlay id="tabOverlay" tabindex="0" style="display: none"></div>
                </p-panel>
        </div>
    </div>
</p-panel>

